import React, { Component } from 'react';
import { bool, func, number, object, string } from 'prop-types';
import MarketPricingChart from 'ps-components/MarketPricingChart/MarketPricingChart';
import MarketPricingDetails from './Details/MarketPricingDetails';
import LoadingChart from '../LoadingStates/LoadingChart';
import './MarketPricing.scss';

class MarketPricing extends Component {
  static propTypes = {
    chartInteraction: func,
    error: string,
    loading: bool,
    neither: number,
    priceJobClick: func,
    adHocPricingClick: func,
    priced: number,
    pricingYear: number,
    slotted: number,
    launchDarklyFeatureFlags: object,
    permissions: object
  };

  constructor(props) {
    super(props);

    this.getPercentPriced = this.getPercentPriced.bind(this);
  }

  getPercentPriced() {
    const { neither, priced, slotted } = this.props;
    return Math.round(((priced + slotted) / (priced + slotted + neither)) * 100);
  }

  render() {
    const {
      chartInteraction,
      error,
      loading,
      neither,
      priceJobClick,
      adHocPricingClick,
      priced,
      pricingYear,
      slotted,
      launchDarklyFeatureFlags,
      permissions
    } = this.props;
    const hasValues = priced >= 0;
    const jobsPricePercentage = hasValues ? this.getPercentPriced() : -1;
    const showMarketPricingChart = hasValues && (!loading || !!error.length);
    const showPlaceholderChart = loading || !!error.length;

    return (
      <div className="home-marketpricing__container">
        <MarketPricingDetails
          jobsPricedPercentage={jobsPricePercentage}
          priceJobClick={priceJobClick}
          adHocPricingClick={adHocPricingClick}
          pricingYear={pricingYear}
          launchDarklyFeatureFlags={launchDarklyFeatureFlags}
          permissions={permissions}
        />
        {showPlaceholderChart && <LoadingChart />}
        {showMarketPricingChart && (
          <div className="home-marketpricing__chart">
            <MarketPricingChart
              chartInteraction={chartInteraction}
              neitherJobsCount={neither}
              pricedJobsCount={priced}
              slottedJobsCount={slotted}
            />
          </div>
        )}
      </div>
    );
  }
}

export default MarketPricing;
